document.addEventListener('submit', function (event) {
  var form = event.target;
  if (!form || !form.matches('.footer-newsletter-form')) {
    return;
  }

  event.preventDefault();

  var status = form.querySelector('.footer-newsletter-status');
  var submit = form.querySelector('.footer-newsletter-submit');
  var csrf = document.querySelector('meta[name="csrf-token"]');
  var originalLabel = submit ? submit.value : '';

  if (status) {
    status.hidden = true;
    status.classList.remove('is-info', 'is-warning', 'is-error');
    status.textContent = '';
  }
  if (submit) {
    submit.disabled = true;
    submit.value = 'Αποθήκευση…';
  }

  fetch(form.action, {
    method: 'POST',
    body: new FormData(form),
    credentials: 'same-origin',
    headers: {
      Accept: 'application/json',
      'X-CSRF-Token': csrf ? csrf.content : ''
    }
  }).then(function (response) {
    return response.json().then(function (payload) {
      return { ok: response.ok, payload: payload };
    });
  }).then(function (result) {
    if (!result.ok) {
      throw new Error((result.payload.errors || []).join(', ') || 'Η εγγραφή δεν ολοκληρώθηκε. Δοκίμασε ξανά.');
    }

    if (status) {
      status.textContent = result.payload.message || 'Η εγγραφή σου στο εβδομαδιαίο email καταχωρίστηκε.';
      status.classList.add(result.payload.tone === 'warning' ? 'is-warning' : 'is-info');
      status.hidden = false;
    }
    form.reset();

    if (result.payload.event && typeof window.gtag === 'function') {
      window.gtag('event', result.payload.event);
    }
  }).catch(function (error) {
    if (status) {
      status.textContent = error.message || 'Η εγγραφή δεν ολοκληρώθηκε. Δοκίμασε ξανά.';
      status.classList.add('is-error');
      status.hidden = false;
    }
  }).then(function () {
    if (submit) {
      submit.disabled = false;
      submit.value = originalLabel;
    }
  });
});
